import { FC } from 'react';

import { ProductsCardsSkeleton } from '@telialt/core-eshop/src/components/ProductsCardsSkeleton/ProductsCardsSkeleton';

import { ESHOP_CATEGORY_TEST_ID } from '../../../constants/test-ids';
import { ProductsAndFacetsContainer } from '../CategoryPage.styles';
import {
    CompaniesSkeleton,
    DescriptionWrapper,
    FacetsSkeleton,
    SkeletonWrapper,
    TitleSkeleton,
} from './CategorySkeleton.styles';

export const CategorySkeleton: FC = () => (
    <SkeletonWrapper data-test={ESHOP_CATEGORY_TEST_ID.CATEGORY_SKELETON}>
        <TitleSkeleton />
        <CompaniesSkeleton />
        <ProductsAndFacetsContainer>
            <FacetsSkeleton />
            <ProductsCardsSkeleton />
        </ProductsAndFacetsContainer>
        <DescriptionWrapper />
    </SkeletonWrapper>
);
